(() => {
  function getSwatchInput(event) {
    if (event.target.matches('.product-card__info [type="radio"]')) {
      return event.target;
    }

    const label = event.target.closest('.product-card__info label');
    if (label && label.control) {
      return label.control;
    }

    return null;
  }

  function syncSwatchToSlider(event) {
    const input = getSwatchInput(event);
    if (!input || !input.hasAttribute('data-variant-media')) return;

    const productCard = input.closest('product-card');
    if (!productCard) return;

    const carousel = productCard.querySelector('[data-slider-carousel]');
    if (!carousel || !carousel.flickityInstance) return;

    let mediaId;
    try {
      mediaId = JSON.parse(input.getAttribute('data-variant-media')).id;
    } catch {
      return;
    }

    const cells = Array.from(carousel.querySelectorAll('[data-slider-cell]'));
    const targetIndex = cells.findIndex((cell) => cell.dataset.mediaId == mediaId);

    if (targetIndex === -1) return;

    carousel.flickityInstance.select(targetIndex);
  }

  document.addEventListener('pointerover', syncSwatchToSlider, true);
  document.addEventListener('change', syncSwatchToSlider, true);

  // スライドを手で動かした時、対応するスワッチも選択状態にする
  document.addEventListener('slider:ready', (event) => {
    const carousel = event.target;
    const flickity = event.detail.flickity;
    const productCard = carousel.closest('product-card');
    if (!productCard) return;

    flickity.on('change', (index) => {
      const cell = carousel.querySelectorAll('[data-slider-cell]')[index];
      if (!cell) return;

      const mediaId = cell.dataset.mediaId;
      const radios = productCard.querySelectorAll('.product-card__info [type="radio"][data-variant-media]');

      radios.forEach((radio) => {
        try {
          const media = JSON.parse(radio.getAttribute('data-variant-media'));
          if (media.id == mediaId && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch {
          /* noop */
        }
      });
    });
  });
})();